import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Container, Link } from '@material-ui/core';


const Faq = () => {
    
    return (
        <Container style={{ marginBottom: 50 }}>
            <Typography variant="h1" component="h2" align='center' > FAQ </Typography>
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>What is total supply of base characters NFT ?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        1000, no more, no less.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>What is the minting cost?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        0.01 SOL each
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Are there additional fees when I resell? What are the royalties? </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    There is a 15% paperhand tax. The royalties are mainly used to support marketing and operational costs.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Where can I buy or sell the Base characters collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>                        
                    After mint, it would be available on secondary market: <Link href="https://magiceden.io/marketplace/">  Magic Eden </Link>
                    </Typography>
                    
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>What is Civic when i want to mint?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>                        
                    Civic Technologies introduces <Link href="https://www.cryptopolitan.com/civic-technologies-anti-bots-tool-on-solana/"> tools </Link> on the Solana network to protect users and website against bot attacks.
                    </Typography>
                    
                </AccordionDetails>
            </Accordion>
        </div>
        </Container>
    );
}

export default Faq;